import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ContentBlock, ContentBlockDto, ContentBlockFactory } from '../models';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getContentBlock(id: string): Observable<ContentBlock[]> {
        return this.httpClient
            .addApiMockIdleInterceptor()
            .skipApiPrefix()
            .skipCredentials()
            .skipRefreshToken()
            .get<{ blocks: ContentBlockDto[]; version: string; time: number }>(`content-blocks/${id}`)
            .pipe(map((data) => data.blocks.map((block) => ContentBlockFactory.create(block))));
    }
}
